module.exports = __webpack_public_path__ + "img/38_22.4cea40e8.png";